import { fetchAssetPreviewDetailsService } from '../services/venues.service';
import { FETCH_REDEEM_ASSET } from './actionNames/redeemActionNames';

export const appendRedeemAssetAction = (assetId: string) => ({
  type: FETCH_REDEEM_ASSET,
  payload: fetchAssetPreviewDetailsService(assetId),
});
